var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user__social-login"},[_c('div',{staticClass:"login-info"},[_c('span',[_vm._v(_vm._s(_vm.$t("user.loginInfo")))])]),_c('Login',{attrs:{"loginTypes":'facebook,google,azure'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }